import { apiSlice } from "../api/apiSlice";

export const quizeMarkApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getQuizeMark: builder.query({
      query: ({ videoId, studentId }) => ({
        url: `/quizMark/?video_id=${videoId}&student_id=${studentId}`,
        method: "GET",
      }),
    }),
  }),
});

export const { useGetQuizeMarkQuery } = quizeMarkApi;
